import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import CartPage from './pages/CartPage';
import ProfilePage from './pages/ProfilePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import FarmerDashboard from './pages/FarmerDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import AddProductPage from './pages/AddProductPage';
import EditProductPage from './pages/EditProductPage';
import MyProductsPage from './pages/MyProductsPage';
import MySalesPage from './pages/MySalesPage';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/common/ProtectedRoute';
import BroadcastMessagePage from './pages/BroadcastMessagePage';
import TelegramOnboardingPage from './pages/TelegramOnboardingPage';

// NOUVELLES IMPORTS PHASE 3 & PARCOURS CUSTOMER
import ReceivedOrdersPage from './pages/ReceivedOrdersPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CheckoutPage from './pages/CheckoutPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen bg-beige">
          <Header />
          <main className="flex-grow">
            <Routes>
              {/* Pages publiques */}
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              
              {/* NOUVELLE ROUTE - Page détail produit (publique avec fonctionnalités conditionnelles) */}
              <Route path="/product/:id" element={<ProductDetailPage />} />
              
              {/* Pages protégées générales */}
              <Route path="/cart" element={<ProtectedRoute element={<CartPage />} />} />
              <Route path="/profile" element={<ProtectedRoute element={<ProfilePage />} />} />
              
              {/* NOUVELLE ROUTE - Checkout protégé pour customers seulement */}
              <Route 
                path="/checkout" 
                element={
                  <ProtectedRoute 
                    element={<CheckoutPage />} 
                    requiredRole="customer"
                  />
                } 
              />
              
              {/* Page Telegram onboarding */}
              <Route 
                path="/telegram/setup" 
                element={<ProtectedRoute element={<TelegramOnboardingPage />} />} 
              />
              
              {/* Pages agriculteur */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute 
                    element={<FarmerDashboard />} 
                    requiredRole="farmer"
                  />
                } 
              />

              {/* ✅ NOUVEAU - Route manquante farmer-dashboard */}
              <Route 
                path="/farmer-dashboard" 
                element={
                  <ProtectedRoute 
                    element={<FarmerDashboard />} 
                    requiredRole="farmer"
                  />
                } 
              />
              
              {/* ROUTE PHASE 3 - Commandes reçues farmer */}
              <Route 
                path="/farmer/orders" 
                element={
                  <ProtectedRoute 
                    element={<ReceivedOrdersPage />} 
                    requiredRole="farmer"
                  />
                } 
              />
              
              <Route 
                path="/add-product" 
                element={
                  <ProtectedRoute 
                    element={<AddProductPage />} 
                    requiredRole="farmer"
                  />
                } 
              />
              <Route 
                path="/edit-product/:id" 
                element={
                  <ProtectedRoute 
                    element={<EditProductPage />} 
                    requiredRole="farmer"
                  />
                } 
              />
              <Route 
                path="/my-products" 
                element={
                  <ProtectedRoute 
                    element={<MyProductsPage />} 
                    requiredRole="farmer"
                  />
                } 
              />
              <Route 
                path="/my-sales" 
                element={
                  <ProtectedRoute 
                    element={<MySalesPage />} 
                    requiredRole="farmer"
                  />
                } 
              />
              
              {/* Pages client */}
              <Route 
                path="/customer-dashboard" 
                element={
                  <ProtectedRoute 
                    element={<CustomerDashboard />} 
                    requiredRole="customer"
                  />
                } 
              />
              
              {/* Pages admin */}
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute 
                    element={<AdminDashboard />} 
                    requiredRole="admin"
                  />
                } 
              />
              <Route 
                path="/admin/broadcast" 
                element={
                  <ProtectedRoute 
                    element={<BroadcastMessagePage />} 
                    requiredRole="admin"
                  />
                } 
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;